import React from "react";
import { Platform, StyleSheet, View } from "react-native";
import { LinearGradient } from "expo-linear-gradient";

/**
 * Soft horizontal rule — spans full width of the parent; strongest in the center, transparent at both ends.
 * Web: CSS `linear-gradient`. Native: `expo-linear-gradient` with tight stops.
 */
const LINE_HEIGHT = 1;

export default function GradientDivider() {
  return (
    <View style={styles.container}>
      {Platform.OS === "web" ? (
        <View style={styles.lineWeb} />
      ) : (
        <LinearGradient
          colors={[
            "rgba(209, 209, 209, 0.0)",
            "rgba(209, 209, 209, 0.08)",
            "rgba(209, 209, 209, 0.45)",
            "rgba(209, 209, 209, 0.95)",
            "rgba(209, 209, 209, 0.95)",
            "rgba(209, 209, 209, 0.45)",
            "rgba(209, 209, 209, 0.08)",
            "rgba(209, 209, 209, 0.0)",
          ]}
          locations={[0, 0.04, 0.14, 0.30, 0.70, 0.86, 0.96, 1]}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 0 }}
          style={styles.lineNative}
        />
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    justifyContent: "center",
    alignItems: "stretch",
  },
  lineWeb: {
    width: "100%",
    alignSelf: "stretch",
    height: LINE_HEIGHT,
    ...(Platform.OS === "web"
      ? ({
          /* Same gray as Colors.borderGrey (#D1D1D1); fades to true transparency at both ends */
          backgroundImage:
            "linear-gradient(90deg, rgba(209,209,209,0) 0%, rgba(209,209,209,0.1) 5%, rgba(209,209,209,0.82) 22%, rgba(209,209,209,0.92) 35%, rgba(209,209,209,0.92) 65%, rgba(209,209,209,0.82) 78%, rgba(209,209,209,0.1) 95%, rgba(209,209,209,0) 100%)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
        } as any)
      : {}),
  },
  lineNative: {
    width: "100%",
    alignSelf: "stretch",
    height: LINE_HEIGHT,
  },
});